import React, { useEffect, useState } from 'react';
import { Card } from 'primereact/card';
import { ProgressBar } from 'primereact/progressbar';
import { HighOverviewReportTypeRes } from '../../../../api/types/reports/high-overview/high-overview.type';

interface BuildingUtilizationProps {
  title: string;
  data: HighOverviewReportTypeRes | undefined;
}

export const BuildingUtilization: React.FC<BuildingUtilizationProps> = ({
  data,
  title,
}) => {
  // Check if dark mode is active
  const [isDarkMode, setIsDarkMode] = useState(false);

  useEffect(() => {
    // Check if dark mode class is applied to body
    const checkDarkMode = () => {
      setIsDarkMode(document.body.classList.contains('dark-mode'));
    };

    // Initial check
    checkDarkMode();

    // Set up observer to detect changes to body class
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === 'class') {
          checkDarkMode();
        }
      });
    });

    // Start observing
    observer.observe(document.body, { attributes: true });

    // Cleanup
    return () => {
      observer.disconnect();
    };
  }, []);

  // Get utilization color based on percentage
  const getUtilizationColor = (percentage: number) => {
    if (percentage >= 70) return '#10b981'; // Green for high utilization (good)
    if (percentage >= 40) return '#f59e0b'; // Yellow for medium utilization
    return '#ef4444'; // Red for low utilization (bad/wasted resources)
  };

  return (
    <div className="building-utilization-section">
      <h2>{title}</h2>
      <div className="utilization-container">
        {data?.realEstateUsage.map((building, index) => {
          // Calculate utilization percentage
          const utilizationPercentage =
            Math.round(
              (building.buildingActualHours / building.capacityHours || 0) *
                100 *
                10,
            ) / 10;

          return (
            <Card key={index} className="utilization-card">
              <div className="utilization-header">
                <span className="building-name">{building.buildingName}</span>
                <span
                  className="utilization-percentage"
                  style={{
                    color: getUtilizationColor(utilizationPercentage),
                    fontWeight: 'bold',
                  }}
                >
                  {utilizationPercentage}%
                </span>
              </div>
              <ProgressBar
                value={utilizationPercentage}
                showValue={false}
                color={getUtilizationColor(utilizationPercentage)}
              />
            </Card>
          );
        })}
      </div>
    </div>
  );
};
